import { ItemTypeMetadata } from "../item-type-metadata.enum";
import { HasShowHideLogic } from "../logic/has-show-hide-logic.model";
import { ShowHideLogicMetadata, ShowHideLogicMetadataBase } from "../logic/show-hide-logic-metadata.model";
import { ObjectJsonSchemaBase } from "../schema/object-json-schema.model";
import { WidgetJsonSchema } from "../schema/widget-json-schema.model";
import { DataSourceOptionMetadata } from "./datasource-option-item-metadata.model";
import { ItemMetadata, ItemMetadataBase } from "./item-metadata.model";


export class DataSourceItemMetadataBase extends ItemMetadataBase implements HasShowHideLogic {

    options: DataSourceOptionMetadata[] = []
    parentSelectFieldName: string | null = null
    dependentOptions: Map<string /* parent value id */, DataSourceOptionMetadata[]> = new Map()
    logicShowHideSection: ShowHideLogicMetadata[] = [new ShowHideLogicMetadataBase()]
    logicShowHideField: ShowHideLogicMetadata[] = [new ShowHideLogicMetadataBase()]

    constructor(type: string) {
        super(type)

        this.addToJsonMethodOnDependentOptions()
    }

    addToJsonMethodOnDependentOptions(): void {
        (<any> this.dependentOptions)["toJSON"] = (): string => {
            return JSON.stringify(Array.from(this.dependentOptions.entries()))
        }
    }

    override from(data: ItemMetadata): void {
        Object.assign(this, data)
        this.dependentOptions = new Map(JSON.parse((<any> data)["dependentOptions"]))
        this.addToJsonMethodOnDependentOptions()
    }

    override schema(): WidgetJsonSchema {
        if (this.type == 'MULTI_CHECKBOX_ITEM') {
            let schema = new ObjectJsonSchemaBase(ItemTypeMetadata.MultiCheckBox)
            this.options.forEach(o => {
                schema.properties[o.id] = { type: 'boolean' }
                schema.required.push(o.id)
            })
            return schema
        }

        let schema: any = { type: 'string', enum: [] }

        this.options.forEach(o => {
            schema.enum.push(o.id)
        })

        return schema
    }

    setDataSourceOptionsMetadataForParentId(id: string, ds: DataSourceOptionMetadata[]) {
        this.dependentOptions.set(id, ds)
    }

    addDataSourceOptionMetadataForParentId(id: string, ds: DataSourceOptionMetadata) {
        let dss = this.dependentOptions.get(id)
        if (dss == undefined) dss = []

        for (let element of dss) {
            if (element.id == ds.id) return
        }

        (<DataSourceOptionMetadata []> dss).push(ds)
        this.dependentOptions.set(id, <DataSourceOptionMetadata []> dss)
    }

    clear() {
        this.dependentOptions.clear()
        this.options.splice(0, this.options.length)
    }

}

export interface DataSourceItemMetadata extends DataSourceItemMetadataBase { }